module.exports = __webpack_public_path__ + "img/cuco_confirm_email.564c0465.png";